<template>
  <v-container id="variacoes-preco-unitario-historico" tag="section" fluid>
    <v-row align="center">
      <v-col cols="12">
        <variacoes-preco-unitario-data-table
          :items="items"
          :loading="loading"
          @rechargeTable="getAllItems()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAllItems())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import VariacoesPrecoUnitarioService from '@/services/VariacoesPrecoUnitarioService';
  import dayjs from 'dayjs';
  import tourMixins from '@/mixins/tourMixins';
  import DateFormatterMixins from '@/mixins/dateFormatterMixins.js';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      VariacoesPrecoUnitarioDataTable: () => import('@/components/variacoesPrecoUnitario/VariacoesPrecoUnitarioDataTable.vue')
    },
    mixins: [DateFormatterMixins, pusherMixins, tourMixins],

    data() {
      return {
        items: [],
        loading: false,
        processamentosExpirados: false,
        arrTour: [
          {
            element: '#btn-nova-variacoes-preco-unitario',
            intro: 'Clicando neste botão você poderá criar novas Variações de Preço Unitário.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#variacoes-preco-unitario-historico-search',
            intro: 'Neste campo você poderá pesquisar por Variações de Preço Unitário já existentes.',
            scrollTo: 'tooltip',
            position: 'bottom'
          },
          {
            element: '#action-visualizar-variacoes-preco-unitario',
            intro: 'Clicando neste ícone você poderá visualizar o resultado da sua Variação de Preço Unitário.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-edit-variacoes-preco-unitario',
            intro: 'Clicando neste ícone você poderá editar sua Variação de Preço Unitário.',
            scrollTo: 'tooltip',
            position: 'left'
          },
          {
            element: '#action-more-variacoes-preco-unitario',
            intro:
              'Aqui você acessa outras opções para sua Variação de Preço Unitário, como ver mais detalhes, executá-la novamente ou deletá-la.',
            scrollTo: 'tooltip',
            position: 'left'
          }
        ]
      };
    },

    mounted() {
      this.subscribe();
      this.getAllItems();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('refresh-variacoes-preco-unitario', () => {
          this.getAllItems();
        });
      },
      getAllItems() {
        this.loading = true;

        VariacoesPrecoUnitarioService.getAllItems(this.processamentosExpirados)
          .then((res) => {
            this.items = [];
            res.data.data.forEach((item) => {
              this.items.push({
                id: item.id,
                nome: item.nome,
                usuario: item.usuario.nome,
                usuario_id: item.usuario.id,
                status: item.status,
                executed: item.data_processamento ? dayjs(item.data_processamento).format('DD/MM/YYYY HH:mm') : '-',
                parametros: JSON.parse(item.parametros)
              });
            });
            this.iniciarTourPagina();
          })
          .catch((err) => {
            this.$toast.error('Erro ao recuperar as Variações de Preço Unitário.', '', { position: 'topRight' });
            console.error(err);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        let arrTourFormatted = this.items.length ? this.arrTour : this.arrTour.splice(0, 2);
        this.iniciarTour(arrTourFormatted);
      }
    }
  };
</script>
